import React from "react";

const GroupCall = () => {
  return <div />; //to be designed
};

export default GroupCall;
